import { useMutation, useQueryClient } from "@tanstack/react-query";
import authAPI from "../../api/auth/api";
import { getQueryKey as getCurrentUserQueryKey } from "./use-get-current-user";

export function useLogout() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: authAPI.logoutUser,
    onSuccess: () => {
      // refetch current user data after logout
      queryClient.removeQueries({ queryKey: getCurrentUserQueryKey() });
    },
    onError: (error) => {},
  });
}
